var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coordinates)?_c('div',{staticClass:"map"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" Ubica tu dirección: ")]),_c('div',{staticClass:"search"},[_c('gmap-autocomplete',{ref:"gmapAutocomplete",staticClass:"autocomplete",attrs:{"id":"gmapAutocomplete","placeholder":"Ingrese dirección","select-first-on-enter":true,"options":{
              fields: ['geometry', 'address_components', 'name', 'formatted_address']
            }},on:{"place_changed":_vm.setPlace}})],1)])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('gmap-map',{ref:"gmap",staticStyle:{"width":"100%","height":"400px"},attrs:{"zoom":_vm.setZoom,"center":_vm.currentLocation,"options":{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: true
        }}},[_c('gmap-marker',{ref:"gmapMarker",attrs:{"id":"gmapMarker","position":_vm.currentLocation,"title":_vm.coordinates.location}})],1)],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }